export default __webpack_public_path__ + "static/media/carewell-logo.7d0df4fb.png";